// extracted by mini-css-extract-plugin
export default {"information":"StaffingInformation_information__UBWIh","tableText":"StaffingInformation_tableText__XQRrs"};